module.exports = __webpack_public_path__ + "static/media/tarot-card-9.56776795.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/mobioastro/assets/images/tarotcards/tarot-card-9.jpg
// module id = 149
// module chunks = 0